<template>
  <GeneralContent />
</template>

<script setup>
import { onMounted } from "vue";
import GeneralContent from "~/components/GeneralContent.vue";

// Referencias
const { trace } = useTraceLog("pages->index.vue");

const route = useRoute();
const router = useRouter();

const removeTrackingParameters = () => {
  // Lista de parámetros de seguimiento a eliminar
  const trackingParams = ['_gl', '_ga', '_gcl_au', '_ga_5V657JNG3L'];

  let newUrl = route.fullPath;
  let modified = false;

  trackingParams.forEach(param => {
    if (route.query[param]) {
      newUrl = newUrl.replace(new RegExp(`[?&]${param}=[^&]*(&|$)`), match =>
        match.endsWith('&') ? '&' : ''
      );
      modified = true;
    }
  });

  // Si la URL termina con "?" o tiene "?&", limpiamos eso también
  newUrl = newUrl.replace(/\?&/, '?').replace(/\?$/, '');

  if (modified) {
    router.replace(newUrl);
  }
};

// Lifecycle hooks
onMounted(() => {
  removeTrackingParameters()
});
</script>